const calculateOffset = (page: number, pageSize: number): number => {
  return (page - 1) * pageSize;
};

const paginationService = {
  calculateOffset,
};

export default paginationService;
